import { render, staticRenderFns } from "./AppNoRecordsPlaceholder.vue?vue&type=template&id=0ffcd38d&scoped=true&"
import script from "./AppNoRecordsPlaceholder.vue?vue&type=script&lang=js&"
export * from "./AppNoRecordsPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./AppNoRecordsPlaceholder.vue?vue&type=style&index=0&id=0ffcd38d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffcd38d",
  null
  
)

export default component.exports